!((document, Drupal) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.video = {
    attach: function() {
      var videoPlayers = '';
      function getId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        var match = url.match(regExp);

        return match && match[2].length === 11 ? match[2] : null;
      }

      function onVideoPlay(event) {
        event.preventDefault();

        // Disable Other Videos
        for (var i = 0; i < videoPlayers.length; i++) {
          var videoPlayerItem = videoPlayers.item(parseInt(i));
          videoPlayerItem.classList.remove('enabled');
          var vidIframe = videoPlayerItem.querySelector('iframe');
          if (vidIframe) {
            videoPlayerItem.removeChild(vidIframe);
          }
        }

        // Hide Poster
        this.classList.add('enabled');

        // Setup iFrame
        var youtubeUrl = this.dataset.youtubeUrl;
        var iframe = document.createElement('iframe');
        var iframeUrl =
          'https://www.youtube.com/embed/' +
          getId(youtubeUrl) +
          '?autoplay=1&modestbranding=1&playsinline=1&rel=0';
        iframe.setAttribute('src', iframeUrl);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        );

        // Add to Player
        this.appendChild(iframe);
      }

      videoPlayers = document.querySelectorAll('.video-player');

      if (videoPlayers) {
        for (var i = 0; i < videoPlayers.length; i++) {
          var videoPlayerItem = videoPlayers.item(parseInt(i));
          var playerButton = videoPlayerItem.querySelector('button');
          playerButton.innerHTML =
            '<svg viewBox="0 0 82.4 82.5" xml:space="preserve"><polygon points="33.3 25.1 57.3 41.1 33.3 57.1"/></svg>';
          videoPlayerItem.addEventListener('click', onVideoPlay ,{passive: true});
        }
      }
    }
  };
})(document, Drupal);
